import React from 'react'
import { string } from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

function ViewAll({ slug }) {
  return (
    <a href={`/blog/${slug}`} className="blog-section-title__link">
      View all
      <Icon type={['far', 'arrow-right']} className="cgt-ml-10" />
    </a>
  )
}

ViewAll.propTypes = {
  slug: string.isRequired,
}

export default ViewAll
